import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faFacebookF, 
  faTwitter, 
  faInstagram, 
  faYoutube 
} from '@fortawesome/free-brands-svg-icons';
import { 
  faLocationDot, 
  faPhone, 
  faEnvelope 
} from '@fortawesome/free-solid-svg-icons';
import './Footer.css';

function Footer() {
  return (
    <footer className="bg-dark text-light py-5 mt-5">
      <Container>
        <Row className="g-4">
          {/* Marka Bilgileri */}
          <Col lg={4} md={6}>
            <h5 className="footer-title">Mr. Brown</h5>
            <p className="footer-description">
              Kişiselleştirilmiş sublimasyon baskılı telefon kılıflarıyla hayalinizdeki tasarımı telefonunuza yansıtın. 
              Yüksek kaliteli baskı teknolojimiz ve özgün tasarımlarımızla tarzınızı yansıtın.
            </p>
            <div className="footer-social">
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer">
                <FontAwesomeIcon icon={faFacebookF} />
              </a>
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer">
                <FontAwesomeIcon icon={faTwitter} />
              </a>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer">
                <FontAwesomeIcon icon={faInstagram} />
              </a>
              <a href="https://youtube.com" target="_blank" rel="noopener noreferrer">
                <FontAwesomeIcon icon={faYoutube} />
              </a>
            </div>
          </Col>

          {/* Hızlı Bağlantılar */}
          <Col lg={2} md={6}>
            <h5 className="footer-title">Hızlı Bağlantılar</h5>
            <ul className="footer-links">
              <li><Link to="/products">Ürünlerimiz</Link></li>
              <li><Link to="/about">Hakkımızda</Link></li>
              <li><Link to="/contact">İletişim</Link></li>
              <li><Link to="/faq">Sıkça Sorulan Sorular</Link></li>
              <li><Link to="/shipping">Kargo Bilgileri</Link></li>
            </ul>
          </Col>

          {/* Politikalar */}
          <Col lg={3} md={6}>
            <h5 className="footer-title">Politikalar</h5>
            <ul className="footer-links">
              <li>
                <Link to="/privacy-policy">Gizlilik Politikası</Link>
              </li>
              <li>
                <Link to="/terms-conditions">Kullanım Koşulları</Link>
              </li>
              <li>
                <Link to="/shipping-policy">Kargo ve Teslimat</Link>
              </li>
              <li>
                <Link to="/return-policy">İade Politikası</Link>
              </li>
              <li>
                <Link to="/distance-sales-agreement">Mesafeli Satış Sözleşmesi</Link>
              </li>
              <li>
                <Link to="/kvkk">KVKK Aydınlatma Metni</Link>
              </li>
            </ul>
          </Col>

          {/* İletişim Bilgileri */}
          <Col lg={3} md={6}>
            <h5 className="footer-title">İletişim</h5>
            <ul className="footer-contact">
              <li>
                <FontAwesomeIcon icon={faLocationDot} />
                <span>
                  Ahatlı Mahalle, 3151 sokak<br />
                  Kepez, Antalya
                </span>
              </li>
              <li>
                <FontAwesomeIcon icon={faPhone} />
                <span>+90 535 873 46 92</span>
              </li>
              <li>
                <FontAwesomeIcon icon={faEnvelope} />
                <span>mr.browncases@gmail.com</span>
              </li>
            </ul>
            <div className="payment-methods mt-4">
              <img 
                src="/images/payment-methods.png" 
                alt="Ödeme Yöntemleri" 
                className="img-fluid"
              />
            </div>
          </Col>
        </Row>
        
        {/* Copyright Section */}
        <Row className="mt-5">
          <Col className="text-center">
            <div className="copyright-text">
              © {new Date().getFullYear()} Mr. Brown - Tüm hakları saklıdır.
            </div>
          </Col>
        </Row>
      </Container>
    </footer>
  );
}

export default Footer; 